<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Third parties applications</div>
</div>

<div class="page-layout flex column padding-large m-margin-none m-padding m-padding-top-largest">
  <h4>Third parties applications</h4>
  <span class="grey small margin-top-smallest margin-bottom">
    {{ exportChannels.length }} export applications are available.
  </span>

  <div class="grid">
    @for (channel of exportChannels; track channel.id) {
      <div class="flex column border radius">
        <div class="flex column start bg-lightest-blue border-bottom">
          <span class="primary small bg-white margin-small padding-right-smallest padding-left-smallest radius">
            Export
          </span>
          <div class="primary-dark flex column center full-width margin-bottom">
            <i class="fa fa-cubes fa-3x"></i>
            <span class="margin-top-small flex center justify-center">
              Basic Studios
              <i class="fa-solid fa-arrow-right margin-left-small margin-right-small grey"></i>
              <b>{{ channel.label }}</b>
            </span>
          </div>
        </div>
        <div class="flex column padding">
          <span class="grey margin-bottom-smallest">Actions:</span>

          <span
            class="primary hover flex gap center"
            [routerLink]="['/company/third-parties-applications', channel.id]"
          >
            <i class="fa fa-arrow-right"></i>
            Manage export templates
          </span>

          @if (channel?.code === 'LEGACY') {
            <span
              [routerLink]="['/company/third-parties-applications/legacy-image-formats']"
              class="primary hover flex gap center"
            >
              <i class="fa fa-arrow-right"></i>
              Manage image formats (TCNIMG)
            </span>
          }
        </div>
      </div>
    }

    <div
      class="flex-1 flex column center primary-dark justify-center bg-light-grey padding hover border radius disabled"
    >
      <i class="fa-regular fa-plus fa-3x"></i>
      <span class="margin-top-small flex center justify-center">Add application</span>
    </div>
  </div>
</div>
